import LegalLink from './LegalLink';
import { LegalLinks, LegalTerms } from './legal-links.enum';

function TermsAndConditions() {
	return (
		<div>
			<p className="text-xs my-4" data-testid="terms-and-conditions">
				By clicking Join, you agree to <span className="font-bold">Haggle</span>
				{"'s "}
				<LegalLink
					href={LegalLinks.USER_AGREEMENT}
					description={LegalTerms.USER_AGREEMENT}
				/>
				,{' '}
				<LegalLink
					href={LegalLinks.PRIVACY_POLICY}
					description={LegalTerms.PRIVACY_POLICY}
				/>
				, and{' '}
				<LegalLink
					href={LegalLinks.COOKIE_POLICY}
					description={LegalTerms.COOKIE_POLICY}
				/>
				.
			</p>
		</div>
	);
}

export default TermsAndConditions;
